//BD: Pergunta
export const enum EGuidTipoSasDocumento {
  'CartaConvite' = 'd2971a14-06ab-449d-9180-2901fa86c161', // Qual o tipo de minuta ?

  'AceiteCartaConvite' = '39ffdef4-87fc-454c-ae66-08ceaa93d495',
  'RecusaCartaConvite' = '8cb4bd77-42e5-406e-8be3-1f1732721e29',


  //24 - Esclarecimentos Técnicos Solicitados
  'EnvioEsclarecimentosTecnicos' = '67859067-10bf-4fa2-b8f6-f67a6ea71e37',
  //25 - Recusa Proposta Comercial
  'RecusaPropostaComercial' = '0cd6ce1b-59ae-4415-bbfb-c61d047b971a',
  //26
  'AceitePropostaComercial' = '044fb343-22c1-4929-8f8a-bec0fb3089d4',
  //27
  'ConsolidacaoEsclarecimentosTecnicos' = '06fe3130-b483-425c-89f3-543df1710113',
  //28
  'RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioP' = '219cd6f1-6d2e-47df-9ea6-fd6840c52603',
  //29
  'AceiteRecebimentoPropostaTecnicasProponentes' = 'c320f471-ba0f-4548-90b9-97826b4cad98',
  //30
  'RecusaRecebimentoPropostaTecnicasProponentes' = '528306ec-f36c-4257-83f8-fcde6559c9e9',
  //33
  'AnexoHomologacao' = '509c3bdd-f106-4115-8617-a9b79f5adc70',

  //38
  'AceiteAnexoSasPropostaRodadaNegociacao' = '07b9d791-3769-44eb-8d86-33aec7afa3a0',

  //41
  'RecusaAnexoSasPropostaRodadaNegociacao' = 'ca5b9a87-8c4d-4cec-9c5e-87918eec913c',
  //41
  'VencedorAnexoSasPropostaRodadaNegociacao' = 'f95e3ab2-5559-489e-b8ef-88ded9cac653',

  'AnexoEnvioNegociacaoMinutaContratual' = '8fea3d13-8ed0-44da-9dc8-c9888c0e2e52',

  'HandOver' = '80612e1c-12d7-4d93-89a7-5e0896a56952'
}